'use strict';

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

require('babel-polyfill');

var environment = {
    development: {
        isProduction: false
    },
    production: {
        isProduction: true
    }
}[process.env.NODE_ENV || 'development'];

module.exports = (0, _assign2.default)({
    host: 'localhost',
    port: 666,
    apiHost: 'https://my.i-retail.com',
    app: {
        title: 'IBonus',
        description: 'IBonus',
        head: {
            titleTemplate: '%s',
            meta: [{ charset: 'utf-8' }, { property: 'og:site_name', content: '' }, { property: 'og:locale', content: 'ru' }, { property: 'og:title', content: '' }, { property: 'og:description', content: '' }]
        }
    },
    checkUrl: 'https://kassa.i-retail.com',
    theme: 'default',
    creditUrl: 'https://loans.tinkoff.ru/api/partners/v1/lightweight/create',
    gapi: {
        key: 'AIzaSyDWmAI4CBvb1gi7HRIuoSstZHqh_ol_ScU'
    }
}, environment);


//////////////////
// WEBPACK FOOTER
// ./src/config/config.js
// module id = 192
// module chunks = 0